export const profile = {
  name: 'William R. Evans',
  headline: 'Global Trade, Treasury & Working Capital Finance Executive',
  tagline: 'Nine sections, each with a single purpose.',
  overview:
    'Purpose-driven executive leader steering complex organizations through digital transformation, capital optimization, and operational scale.',
  primaryFocus:
    'Strategic board governance, high-stakes risk management, and scalable enterprise growth.',
  portrait:
    'https://cdn.magicpatterns.com/uploads/ih8vWcb7d88nr62DWdTnCT/William_Evans.jpg',
  location: 'Wake Forest, NC',
  phone: '(908) 451-9074',
  phoneHref: 'tel:+19084519074',
  email: 'bill.r.evans88@gmail.com',
  linkedIn: 'https://www.linkedin.com/in/william-evans-7704417/',
  resumeUrl: '#resume',
  availability:
    'Open to global public and private corporate board appointments.',
}

export const about = {
  identity:
    'Visionary C-suite executive with extensive governance expertise across global enterprise environments.',
  philosophy:
    'Unlocking organizational value by bridging long-term strategic vision with disciplined operational execution.',
  attributes: [
    'Forward-thinking risk management',
    'Strong fiduciary oversight',
    'Ethical leadership',
    'Stakeholder alignment',
  ],
}
